import React from "react";

const ConsultingPyramid = () => {
  const pyramidLayers = [
    {
      text: "Fewer entry-level analyst",
    },
    {
      text: "A strong middle of experienced consultants and technologists",
    },
    {
      text: "A hands-on leadership layer",
    },
  ];

  return (
    <div className="w-full py-16 lg:py-12 relative border-[#5b6882] border-t">
      <div className="w-[88%] lg:w-[80%] mx-auto relative">
        {/* Header Section */}
        <div className="mb-12 lg:mb-16">
          <h2 className="text-[32px] md:text-[40px] lg:text-[48px] xl:text-[56px] text-fluoro-green RoobertLight leading-[120%] mb-4">
            Rethinking the Consulting Pyramid
          </h2>
          <h3 className="text-[20px] md:text-[22px] lg:text-[24px] xl:text-[28px] text-fluoro-green RoobertMedium leading-[120%] mb-4">
            Why OBZ is building a diamond-shaped organization:
          </h3>
          <div className="space-y-4 text-white RoobertRegular text-[16px] md:text-[17px] lg:text-[18px] leading-[140%]">
            <p>
              Traditional consulting firms are built like pyramids — many
              juniors at the bottom, a few experts at the top.
            </p>
            <p>At OBZ, we're doing things differently.</p>
            <p>
              We're building a{" "}
              <span className="font-bold text-fluoro-green">
                diamond-shaped organization
              </span>
              :
            </p>
          </div>
        </div>

        {/* Traditional Pyramid Layers */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-16 mb-12 lg:mb-16">
          {pyramidLayers.map((layer, index) => (
            <div
              key={index}
              className={`bg-white p-6 text-black RoobertMedium text-[16px] md:text-[17px] lg:text-[18px] leading-[140%] text-center relative`}
            >
              <p>{layer.text}</p>

              <div className="border-r-4 border-t-4 border-[#00FF88] absolute top-0 right-0 w-1/4 h-1/2"></div>
            </div>
          ))}
        </div>

        {/* Delivery Approach Section */}
        <div className="mb-12 lg:mb-16">
          <p className="text-white RoobertRegular text-[16px] md:text-[17px] lg:text-[18px] leading-[140%] mb-4">
            This reflects how we deliver. Clients today don't need armies — they
            <span className="font-bold text-fluoro-green">
              {" "}
              need compact, outcome-aligned teams
            </span>{" "}
            that combine domain expertise, execution maturity, and intelligent
            automation.
          </p>
          <p className="text-white RoobertRegular text-[16px] md:text-[17px] lg:text-[18px] leading-[140%]">
            With AI coworkers handling repetitive tasks, our human teams focus
            on strategy, architecture, and high-value decision-making.
          </p>
        </div>

        <div className="bg-white p-12">
          {/* Main Diagram Section */}
          <div className="mb-8 text-center">
            <h3 className="text-black RoobertMedium text-[20px] md:text-[22px] lg:text-[24px] leading-[140%] mb-8">
              We've shaped OBZ as a diamond, not a pyramid:<br /> a strong, lean core.
              Expert-led, tech-enabled, and now agent-augmented
            </h3>
          </div>

          {/* Diamond vs Pyramid Comparison */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-end">
            {/* OBZ Diamond Diagram */}
            <div className="flex justify-center lg:justify-start">
              <img
                src="/images/story/consulting_pyramid.svg"
                alt="OBZ Diamond Diagram"
                className="w-full h-auto max-w-md lg:max-w-lg"
              />
            </div>

            {/* Comparison Section */}
            <div className="space-y-8">
              {/* Traditional Pyramid */}
              <div className="p-6 text-center">
                <h4 className="text-[#0A1931] RoobertSemiBold text-[18px] md:text-[20px] mb-4">
                  Traditional consulting pyramid
                </h4>
                <ul className="space-y-2 text-[#0A1931] RoobertRegular text-[14px] md:text-[16px]">
                  <li>High ramp-up time</li>
                  <li>Billable hours &gt; business outcomes</li>
                  <li>Trained on the client's time</li>
                  <li>Rigid and slow to adapt</li>
                </ul>
                <div className="mt-6 flex justify-center">
                  <div className="w-0 h-0 border-l-[12px] border-r-[12px] border-t-[16px] border-l-transparent border-r-transparent border-t-[#00FF88]"></div>
                </div>
              </div>

              {/* New AI-Powered Paradigm - Trapezoidal Shape */}
              <div
                className="relative bg-dark-blue p-6 rounded-lg text-center"
                style={{
                  clipPath: "polygon(15% 0%, 85% 0%, 100% 100%, 0% 100%)",
                }}
              >
                <h4 className="text-[#00FF88] RoobertSemiBold text-[18px] md:text-[20px] mb-4">
                  Our New AI-Powered Paradigm
                </h4>
                <ul className="space-y-2 text-white RoobertRegular text-[14px] md:text-[16px]">
                  <li>AI replaces repetitive junior work</li>
                  <li>Strong mid-core = faster outcomes</li>
                  <li>Experts lead with ownership, not hierarchy</li>
                  <li>Lean, fast, and focused</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultingPyramid;
